"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ui = require("@unite-us/ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProviderCardLoading = function ProviderCardLoading() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-provider-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-provider-card__info"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-provider-card__detail"
  }, /*#__PURE__*/_react["default"].createElement(_ui.BarLoader, {
    className: "mb-half",
    tall: true,
    size: "semi-full"
  }), /*#__PURE__*/_react["default"].createElement(_ui.BarLoader, {
    className: "mb-half",
    size: "quarter"
  }), /*#__PURE__*/_react["default"].createElement(_ui.BarLoader, {
    className: "mb-half",
    size: "half"
  }), /*#__PURE__*/_react["default"].createElement(_ui.BarLoader, {
    className: "mb-half",
    size: "half"
  }))));
};
var _default = exports["default"] = ProviderCardLoading;